import React, { Fragment, useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import ErrorMessage from "../Misc/ErrorMessage";
import Tip from "../Misc/Tip";
import { SuperSelect } from "../Misc/SuperSelect";

export default function LocationField({ title, tip = null }) {
  const {
    locations,
    order,
    setOrder
  } = useContext(CarOrderingContext)

  const location = order.pickup_location ?? ''
  const useSelectForDealers = Object.keys(locations).length > 10

  const onchange = function (value) {
    let newOrder = { ...order }
    newOrder.pickup_location = value
    setOrder({ ...newOrder })
  }

  const LocationList = (locations) => {
    return Object.keys(locations).map((key) => (
      <Fragment key={key}>
        <input
          onChange={() => onchange(key)}
          type='radio'
          name='pickup_location'
          id={'paymentradio_location_' + locations[key]}
          value={key}
          defaultChecked={location === key}
        />
        <label htmlFor={'paymentradio_location_' + locations[key]} className='config-radio__radio' data-layout='standard'>
          {locations[key]}
        </label>
      </Fragment>
    ))
  }

  const locationObjects = useSelectForDealers
    ? Object.entries(locations).map(([key, val]) => ({ ...val, id: key }))
    : Object.fromEntries(Object.entries(locations).map(([key, val]) => [key, typeof val === 'string' ? val : val.title]))

  const locationElements = useSelectForDealers
    ? (<SuperSelect
        onChange={(value) => onchange(value?.id)}
        locations={locationObjects}
        location={locations[location] ? { ...locations[location], id: location } : null}
      />)
    : LocationList(locationObjects)

  return (
    <>
      <h2 className='config-form__subtitle'>
        {title}
        {typeof tip === 'string' && tip.length > 0 ? <Tip content={tip}/> : null}
      </h2>

      <div className='config-radio'>{locationElements}</div>
      <ErrorMessage field='pickup_location'/>
      <div className='config-form__separator'/>
    </>
  )
}
